/**
 * Application Constants
 */

export const STRATEGY_OPTIONS = [
  'MACD Crossover',
  'Moving Average Crossover',
  'Bollinger Bands',
  'RSI Strategy',
  'Price + Volume Breakout',
  'Volume + ATR Breakout',
  'Volatility Squeeze',
  'RSI Divergence',
  'MACD Divergence'
];

export const INDICES = {
  'nifty_50': 'Nifty 50',
  'fno': 'F&O Eligible',
  'nifty_bank': 'Nifty Bank',
  'nifty_it': 'Nifty IT',
  'nifty_pharma': 'Nifty Pharma',
  'nifty_auto': 'Nifty Auto',
  'nifty_fmcg': 'Nifty FMCG',
  'nifty_metal': 'Nifty Metal',
  'nifty_realty': 'Nifty Realty'
};

/** All index IDs for filter dropdowns; no server fetch needed. */
export const INDEX_OPTIONS = [
  'fno',        // F&O Eligible — pinned to the top of the dropdown
  'nifty_50',
  'nifty_500',
  'nifty_100',
  'nifty_200',
  'nifty_next_50',
  'nifty_midcap_50',
  'nifty_midcap_100',
  'nifty_midcap_150',
  'nifty_smallcap_50',
  'nifty_smallcap_100',
  'nifty_smallcap_250',
  'nifty_large_midcap_250',
  'nifty_midsmallcap_400',
  'nifty_bank',
  'nifty_financial_services',
  'nifty_private_bank',
  'nifty_psu_bank',
  'nifty_it',
  'nifty_pharma',
  'nifty_healthcare',
  'nifty_fmcg',
  'nifty_consumer_durables',
  'nifty_auto',
  'nifty_metal',
  'nifty_infrastructure',
  'nifty_realty',
  'nifty_media',
  'nifty_energy',
  'nifty_oil_gas',
  'Other'
];

/** Default index filter for dashboard / overview — Nifty 100 until the user picks another. */
export const DEFAULT_INDEX_ID = 'nifty_100';
export const DEFAULT_INDEX_FILTER = [DEFAULT_INDEX_ID];

/** Legacy pulse default — Setups now hydrates index from dashboard_filters_v1 (same as Scan). */
export const DEFAULT_PULSE_INDEX = ['fno'];

export const SIGNAL_TYPES = {
  'BUY': 'BUY',
  'SELL': 'SELL'
};
